import { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import * as S3ImageUpload from '@/types/s3imageUpload';
import ajax from '@/utils/ajax';

export const s3ImageRepository = {
  async getPresignedFileUploadConfig({
    host,
    config: { contentType, pictureKind },
    personId
  }: {
    host: string;
    config: S3ImageUpload.PresignedFileUploadConfigPayload;
    personId: string;
  }): Promise<S3ImageUpload.UploadConfigResponse> {
    const requestBody: S3ImageUpload.RequestBody = {
      content_type: contentType,
      picture_kind: pictureKind,
      person_id: personId
    };
    const path = '/api/dugout/s3_upload/config/';
    const { data } = await ajax.post<S3ImageUpload.RequestBody, AxiosResponse>({
      url: `${host}${path}`,
      data: requestBody,
      config: {
        withCredentials: true
      }
    });

    return data;
  },

  async uploadToS3({
    file,
    config
  }: {
    file: S3ImageUpload.FileToUpload | string | Blob;
    config: S3ImageUpload.PresignedUploadConfig;
  }): Promise<{ status: number }> {
    const fileFormData = new FormData();

    Object.entries(config.fields).forEach(([fieldKey, fieldValue]) => {
      fileFormData.append(fieldKey, fieldValue);
    });
    fileFormData.append('file', file as string | Blob);

    const response = await ajax.post<FormData, AxiosResponse>({
      url: config.url,
      data: fileFormData,
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    return { status: response.status };
  }
};

const S3ImageRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getPresignedFileUploadConfig(
      config: S3ImageUpload.PresignedFileUploadConfigPayload,
      personId: string
    ) {
      return s3ImageRepository.getPresignedFileUploadConfig({ host, config, personId });
    },
    async uploadToS3({
      file,
      config
    }: {
      file: S3ImageUpload.FileToUpload | string | Blob;
      config: S3ImageUpload.PresignedUploadConfig;
    }): Promise<{ status: number }> {
      return s3ImageRepository.uploadToS3({ file, config });
    }
  };
};

export default S3ImageRepository;
